import { RequestParams } from "../types";

export type CacheParams = {
	path: string,
	params?: RequestParams
}

export class ServiceCache {

	private cache: Map<string, unknown> = new Map();

	constructor() { }

	private createKey(params: CacheParams): string {
		let key = params.path;
		if (params.params) {
			const paramStrings: string[] = [];
			for (const k of Object.keys(params.params).sort()) {
				paramStrings.push(`${k}=${params.params[k]}`);
			}
			if (paramStrings.length > 0) {
				key += `?${paramStrings.join('&')}`;
			}
		}
		return key;
	}

	set<T = unknown>(params: CacheParams, data: T) {
		const key = this.createKey(params);
		this.cache.set(key, data);
	}

	get<T = unknown>(params: CacheParams): T | undefined {
		const key = this.createKey(params);
		return this.cache.get(key) as T;
	}

	has(params: CacheParams): boolean {
		const key = this.createKey(params);
		return this.cache.has(key);
	}

	clear() {
		this.cache.clear();
	}

}
